import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

type StatusProps = {
  status:
    | 'InStock'
    | 'OutOfStock'
    | 'MarkedOutOfStock'
    | 'PartialOutOfStock'
    | 'ErpInStock'
    | 'ErpOutOfStock';
};

const baseStyle = {
  display: 'inline-block',
  lineHeight: '18px',
  padding: '3px 8px',
  fontSize: '12px',
  borderRadius: '2px',
} as const;

const StatusTag = memo((props: StatusProps) => {
  const { status } = props;
  const { t } = useTranslate();

  if (status === 'InStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-warning-text)',
          background: 'var(--fett-surface-warning-bg)',
        }}
      >
        {t('domain.product.inventoryStatus.platformOutOfStock')}
      </div>
    );
  }
  if (status === 'MarkedOutOfStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-error-text)',
          background: 'var(--fett-surface-error-bg)',
        }}
      >
        {t('domain.product.inventoryStatus.manuallyMarkedOutOfStock')}
      </div>
    );
  }
  if (status === 'OutOfStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-success-text)',
          background: 'var(--fett-surface-success-bg)',
        }}
      >
        {t('ViewDashboard.LAZADA.Out of stock')}
      </div>
    );
  }
  if (status === 'PartialOutOfStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-success-text)',
          background: 'var(--fett-surface-success-bg)',
        }}
      >
        {t('domain.product.inventoryStatus.partialSkuOutOfStock')}
      </div>
    );
  }
  if (status === 'ErpInStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-info-text)',
          background: 'var(--fett-surface-info-bg)',
        }}
      >
        {t('domain.product.inventoryStatus.inStockOnErp')}
      </div>
    );
  }
  if (status === 'ErpOutOfStock') {
    return (
      <div
        style={{
          ...baseStyle,
          color: 'var(--fett-surface-error-text)',
          background: 'var(--fett-surface-error-bg)',
        }}
      >
        {t('domain.product.inventoryStatus.outOfStockOnErp')}
      </div>
    );
  }
  return null;
});

export default StatusTag;
